import { render } from "./PaySuccess.vue?vue&type=template&id=5c284770&ts=true"
import script from "./PaySuccess.vue?vue&type=script&lang=ts"
export * from "./PaySuccess.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__